import {useEffect} from 'react'

export function useSiteMeta() {
  useEffect(() => {
    const title = process.env.REACT_APP_SITE_TITLE || 'Default Title'
    const faviconPath =
      process.env.REACT_APP_FAVICON_URL || '/coupons.ca-favicon.ico'

    document.title = title

    let link = document.querySelector(
      'link[rel="icon"]'
    ) as HTMLLinkElement | null
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      link.type = 'image/x-icon'
      document.head.appendChild(link)
    }
    link.href = faviconPath
  }, [])
}
